import { render, staticRenderFns } from "./fiveColumnCard.vue?vue&type=template&id=6b2f1217&scoped=true"
import script from "./fiveColumnCard.vue?vue&type=script&lang=js"
export * from "./fiveColumnCard.vue?vue&type=script&lang=js"
import style0 from "./fiveColumnCard.vue?vue&type=style&index=0&id=6b2f1217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f1217",
  null
  
)

export default component.exports